import React, { useEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import store from '~/data/store/store'

import MergeTags from '~/pages/cp/includes/mergeTags/mergeTags'

const mpMergeTagsDropdown = ({ selectTag = () => {}, isLandingPage = false, campaign = {} }) => {
    useEffect(() => {}, [])

    return (
        <Provider store={store}>
            <div className='templateEditor-redactorplugins-mpMergeTags'>
                <MergeTags
                    landingPage={isLandingPage}
                    campaign={campaign}
                    AutomationId={campaign ? campaign.AutomationId : undefined}
                    onTagClick={selectTag}
                    minimal={true}
                />
            </div>
        </Provider>
    )
}

export default mpMergeTagsDropdown
